/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: axios 拦截器封装
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-15 20:19:36
 * @LastEditTime: 2023-04-07 15:03:28
 * @FilePath: /client-h5-v2/src/request/index.ts
 */
import axios from 'axios'
import secret from '@/common-ts/secret' // 加密解密
import store from '@/store/index'
import CancelRequest from './cancelRequest'
// 实例化
const cancelRequest = new CancelRequest()
// const CancelToken = axios.CancelToken
// 创建一个 axios 实例
const service = axios.create({
  baseURL: `/${window.botV2GlobalProperties.BASE_PATH}`, // 请求地址前缀
  timeout: 60000, // 请求超时时间（毫秒）
  withCredentials: true, // 异步请求是否携带cookie
  headers: {
    'Content-Type': 'application/json',
    'token': '',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// 使用请求拦截器
service.interceptors.request.use(
  function (config:any) {
    // 检查之前是否存在相同的请求，如果存在则取消。不存在就记录
    // cancelRequest.checkoutPendingRequest(config, CancelToken)
    if (config.method === 'post') {
      if (config.data.isEncrypt) {
        // 除了日志接口剩下的交互接才清除按钮
        if (config.url?.indexOf('printLog') === -1) {
          store.commit('dialog/CLEAR_BTN')
        }
        config.data = secret.EncryptData(JSON.stringify(config.data))
      }
    }
    // 发送请求之前做什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

// 使用响应拦截器
service.interceptors.response.use(
  function (response) {
    // 移除成功请求记录
    cancelRequest.removeRequestKey(response.config)
    if ((typeof response.data) === 'string') {
      // 清除loading
      store.commit('dialog/CLEAR_LOADING')
      response.data = secret.DecryptData(response.data)
    }
    return response
  },
  function (error) {
    console.log(error)
    cancelRequest.removeRequestKey(error)
    return Promise.reject(error)
  }
)

export default service
